(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-result/assets/react/components/map-single.js');

'use strict';

const {
  useEffect,
  useMemo,
  useState
} = React;
const {
  getResultMapHandler
} = svs.lyckoplatsen.components.shared_map;
const {
  PinIcon
} = svs.lyckoplatsen.shared_utils.react.components;
const Button = svs.ui.ReactButton;
const {
  useAtomValue,
  useAtom
} = jotai;
const {
  correctionStepAtom,
  selectedHighlightedWinGroupAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  mapErrorDialogNoRedirect
} = svs.lyckoplatsen.shared_map.utils;
const MapSingle = _ref => {
  let {
    mapId = 'map-single-pin',
    wagers = null,
    result,
    showBtnCenterSweden = false
  } = _ref;
  const mapHandlerResult = useMemo(() => getResultMapHandler(), []);
  const [highlightedWinGroup, setHighlightedWinGroup] = useAtom(selectedHighlightedWinGroupAtom);
  const correctionStep = useAtomValue(correctionStepAtom);
  const [showCenterSwedenButton, setShowCenterSwedenButton] = useState(false);
  const [showCenterWagersButton, setShowCenterWagersButton] = useState(false);
  const [showCenterWinCircleButton, setShowCenterWinCircleButton] = useState(false);
  const [mapCenter, setMapCenter] = useState(true);
  const [circlesReady, setCirclesReady] = useState(false);
  const winGroupClass = highlightedWinGroup || highlightedWinGroup === 0 ? "lp-wingroup-".concat(highlightedWinGroup) : '';
  const handleCenterSwedenClick = () => {
    mapHandlerResult.centerSweden();
  };
  const handleCenterWinCircleClick = () => {
    setMapCenter(true);
    mapHandlerResult.centerWinCircle();
    if (highlightedWinGroup !== null) {
      setHighlightedWinGroup(null);
    }
  };
  const handleCenterWagersClick = () => {
    setMapCenter(false);
    mapHandlerResult.centerWagers();
    setHighlightedWinGroup(null);
  };

  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      geoJsonInv: true,
      maxBounds: [[72.1, -5.5], [47.1, 39.5]],
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      dragging: true,
      boxZoom: true,
      touchZoom: true,
      showErrorOverlay: false,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      highlightedWinGroup: index => setHighlightedWinGroup(index),
      showCenterSwedenButton: bool => setShowCenterSwedenButton(bool),
      showCenterWagersButton: bool => setShowCenterWagersButton(bool),
      showCenterWinCircleButton: bool => setShowCenterWinCircleButton(bool),
      resultRendered: () => {
        setCirclesReady(true);
      }
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    return () => mapHandlerResult.removeMap();
  }, [mapHandlerResult, mapId, setHighlightedWinGroup, result]);
  useEffect(() => {
    if (result && correctionStep) {
      const winGroups = result.distribution;
      const winningLocation = result.location;
      mapHandlerResult.showResult({
        winGroups,
        winningLocation
      });
    }
    if (!correctionStep) {
      mapHandlerResult.fitBoundsSweden();
    }
  }, [correctionStep, mapHandlerResult, result]);
  useEffect(() => {
    if (wagers) {
      mapHandlerResult.showWagers(wagers, result);
      return () => mapHandlerResult.removeWagers();
    }
  }, [mapHandlerResult, wagers, result]);


  useEffect(() => {
    if (!mapCenter && highlightedWinGroup !== null && highlightedWinGroup !== 'zoomed') {
      setMapCenter(true);
    }
  }, [highlightedWinGroup, mapCenter]);
  useEffect(() => {
    if (highlightedWinGroup === 0) {
      mapHandlerResult.selectSinglePin();
      mapHandlerResult.moveToWinGroup(0);
      return () => mapHandlerResult.clearSelectedSinglePin();
    }
    if (highlightedWinGroup === 'zoomed') {
      mapHandlerResult.moveToWinGroup(0, true);
    } else if (result && correctionStep && circlesReady && mapCenter) {
      mapHandlerResult.moveToWinGroup(highlightedWinGroup);
    }
  }, [correctionStep, highlightedWinGroup, mapHandlerResult, result, circlesReady, mapCenter]);

  useEffect(() => {
    if (wagers && correctionStep && circlesReady) {
      mapHandlerResult.centerWagers();
    }
  }, [correctionStep, mapHandlerResult, circlesReady, wagers]);
  return React.createElement("div", {
    className: "result-map ".concat(winGroupClass, " ").concat(wagers ? 'has-wagers' : '')
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), correctionStep !== 0 && React.createElement(Button, {
    disabled: !showCenterWinCircleButton,
    className: "lp-btn-center-map ".concat(showCenterWinCircleButton ? '' : 'disable'),
    onClick: handleCenterWinCircleClick
  }, React.createElement(PinIcon, {
    color: "green"
  })), wagers && React.createElement(Button, {
    disabled: !showCenterWagersButton,
    className: "lp-btn-center-wagers ".concat(showCenterWagersButton ? '' : 'disable'),
    onClick: handleCenterWagersClick
  }, React.createElement(PinIcon, {
    color: "red"
  })), showBtnCenterSweden && React.createElement(Button, {
    disabled: !showCenterSwedenButton,
    className: "lp-btn-center-sweden ".concat(showCenterSwedenButton ? '' : 'disable'),
    onClick: handleCenterSwedenClick
  }, React.createElement("svg", {
    fill: "#FFFFFF",
    viewBox: "0 0 112 260",
    enableBackground: "new 0 0 112 260",
    xmlSpace: "preserve",
    role: "img",
    "aria-labelledby": "center-map-icon-title"
  }, React.createElement("title", {
    id: "center-map-icon-title"
  }, "Knappen: Visa hela Sverige"), React.createElement("polygon", {
    points: "109.627,57.925 104.224,46.74 105.859,39.394 95.337,12.782 88.204,10.294 79.555,2 75.692,3.421 73.773,14.085 61.474,11.431 47.872,32.711 50.099,39.583 43.346,52.711 36.308,57.001 34.53,75.864 28.891,85.698 31.094,96.456 20.739,97.191 14.506,109.395 16.426,128.495 14.648,138.661 20.762,145.486 16.592,168.756 8.321,178.827 9.293,184.681 2.373,189.562 2.61,200.179 8.866,203.923 8.843,215.795 18.203,236.838 18.345,255.511 21.497,258 33.037,254.872 35.123,245.014 48.654,244.35 56.758,218.354 57.114,196.648 72.517,186.6 76.617,174.941 66.545,159.609 61.569,159.348 58.607,144.964 61.593,130.888 61.829,125.248 75.811,105.627 87.304,97.001 92.304,86.267 91.593,74.086 96.024,58.636 "
  }))));
};
Object.assign(svs.lyckoplatsen.components.shared_result.react.components, {
  MapSingle
});

 })(window);